<template>
	<div class="pui-form">
		<mtipocarga-modals :modelName="modelName"></mtipocarga-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtipocarga-form-header
				:modelPk="modelPk"
			></mtipocarga-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPOCARGA -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtipocarga-mtipocarga`"
									v-model="model.idtipocarga"
									:label="$t('mtipocarga.idtipocarga')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODTIPOCARGAEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codtipocargaedi-mtipocarga`"
									v-model="model.codtipocargaedi"
									:label="$t('mtipocarga.codtipocargaedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="3"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md6>
								<pui-text-field
									:id="`name-mtipocarga`"
									v-model="model.name"
									:label="$t('mtipocarga.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="100"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtipocarga`"
									v-model="model.fecbaja"
									:label="$t('mtipocarga.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtipocargaActions from './MtipocargaActions';
import mtipocargaModals from './MtipocargaModals.vue';

export default {
	name: 'mtipocarga-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtipocarga-modals': mtipocargaModals
	},
	data() {
		return {
			modelName: 'mtipocarga',
			actions: mtipocargaActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtipocarga');
		}
	},
	created() {}
};
</script>
